import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { EASE } from './Shared';
import { buyers } from '../data/pack';
export function FloatingNotification() {
  const [visible, setVisible] = useState(false);
  const [buyer, setBuyer] = useState(buyers[0]);
  useEffect(() => {
    const initial = window.setTimeout(() => setVisible(true), 5000);
    const cycle = window.setInterval(() => {
      setVisible(false);
      window.setTimeout(() => {
        setBuyer(buyers[Math.floor(Math.random() * buyers.length)]);
        setVisible(true);
      }, 850);
    }, 30000);
    return () => {
      window.clearTimeout(initial);
      window.clearInterval(cycle);
    };
  }, []);
  return <AnimatePresence data-id="element-119" data-mp="2bvuxofuvpq2f">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 12,
      scale: 0.97
    }} transition={{
      duration: 0.25,
      ease: EASE
    }} aria-live="polite" className="fixed bottom-4 left-4 z-40 max-w-xs md:bottom-8 md:left-8 md:max-w-sm" data-id="element-120" data-mp="2bwmgeq3dntba">
          <div className="flex items-start gap-3 border-l-4 border-brand-jade bg-brand-paper p-4 shadow-[0_14px_34px_rgba(36,28,20,0.25)]" data-id="element-121" data-mp="1vuxrug6lh82a">
            <span className="mt-0.5 rounded-sm bg-brand-jadeMist p-2" data-id="element-122" data-mp="1mwvj1egmdb4g">
              <CheckCircle2Icon className="h-5 w-5 text-brand-jade" aria-hidden="true" data-id="element-123" data-mp="1myoqgvz23zdi" />
            </span>
            <div className="min-w-0" data-id="element-124" data-mp="1d6j1lv43py2j">
              <p className="text-[11px] text-brand-muted" data-id="element-125" data-mp="1d5hprof9h7jr">Compra verificada · hace unos minutos</p>
              <p className="mt-0.5 text-sm text-brand-ink" data-id="element-126" data-mp="188hk3embq6t6">
                <strong data-id="element-127" data-mp="138d37nhi7a2f">{buyer.name}</strong> de {buyer.location} accedió al
              </p>
              <p className="font-title text-sm text-brand-jadeDeep" data-id="element-128" data-mp="136ihi6yerdxa">Feng Shui Negocios™</p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}